import { gql } from '@ori/fetching';

import { searchPreviewShade } from './shade';

export const conceptFragment = gql`
  ${searchPreviewShade}
  fragment BaseConcept on Concept {
    name
    brand {
      name
    }
    categories {
      name
    }
    products {
      ...SearchPreviewShade
    }
    labels {
      ...ProductLabels
    }
  }
`;
